<script setup lang="ts">
import type { BaseContentResponseModel } from '@su4r-frontend/api';

defineProps<{ data: BaseContentResponseModel }>();
</script>

<template>
    <div class="container grid">
        <template
            v-for="(component, index) in data.components"
            :key="`${component.alias}-${index}`">
            <component :is="mapComponentAlias(component.alias ?? '')" v-bind="{ ...component }" />
        </template>
    </div>
</template>
